export const TopBar = () => {
  return (
    <div className="bg-secondary border-b border-border">
      <div className="container mx-auto px-6 py-3 flex items-center justify-between">
        <div className="text-foreground text-xs sm:text-sm font-medium">
          datasyteAI™ — Expert-trained decision support for Code Blue
          <span className="hidden sm:inline">
            {" "}
            · Pre-market: not FDA cleared, not for clinical use
          </span>
        </div>
      </div>
    </div>
  );
};
